(() => {
  if (customElements.get('furlab-tool-picks')) return;
  const requests = new Map();
  const fetchPool = url => {
    if (!requests.has(url)) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 7000);
      const request = fetch(url, { credentials: 'same-origin', signal: controller.signal })
        .then(response => { if (!response.ok) throw new Error('Pool unavailable'); return response.text(); })
        .then(html => [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-fltp-card]')])
        .finally(() => clearTimeout(timeout));
      requests.set(url, request);
    }
    return requests.get(url);
  };
  customElements.define('furlab-tool-picks', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'pending';
      const load = async () => {
        const grid = this.querySelector('[data-fltp-grid]');
        if (!grid) return;
        const excluded = this.dataset.currentProduct;
        let cards = [...grid.querySelectorAll('[data-fltp-card]')];
        let source = 'bestseller-snapshot';
        try {
          const live = (await fetchPool(this.dataset.poolUrl)).filter(card => card.dataset.productId !== excluded);
          if (live.length >= 5) { cards = live; source = 'live-bestsellers'; }
        } catch (error) {}
        cards = cards.filter(card => card.dataset.productId !== excluded);
        this.dataset.poolCount = String(cards.length);
        for (let i = cards.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [cards[i], cards[j]] = [cards[j], cards[i]];
        }
        grid.replaceChildren(...cards.slice(0, 5).map(card => card.cloneNode(true)));
        this.dataset.source = source;
        this.dataset.ready = 'true';
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); load(); }
        }, { rootMargin: '600px' });
        observer.observe(this);
      } else load();
    }
  });
})();
